"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const FieldErrorSection_1 = require("@Components/Fields/FieldErrorSection");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const string_escape_newlines_1 = require("@App/helpers/string-escape-newlines");
class InputText extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "inputValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.value || null
        });
        Object.defineProperty(this, "activeInputState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "onFocusInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.activeInputState = true;
            }
        });
        Object.defineProperty(this, "setInputInitValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.inputValue = value ? value : '';
            }
        });
        Object.defineProperty(this, "onBlurInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.activeInputState = false)
        });
        Object.defineProperty(this, "handleChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                this.inputValue = event.target.value;
                this.onSave();
            }
        });
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.inputValue !== null) {
                    this.props.onChange(this.inputValue, this.props.id, this.props.label);
                }
            }
        });
        (0, mobx_1.makeObservable)(this, {
            inputValue: mobx_1.observable,
            activeInputState: mobx_1.observable,
            onFocusInput: mobx_1.action,
            setInputInitValue: mobx_1.action,
            onBlurInput: mobx_1.action,
            handleChange: mobx_1.action,
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setInputInitValue(this.props.value);
        }
    }
    render() {
        const { mainColor, disabled, id, label, assistiveText, errorMessage, password, autoComplete = 'off', helperTitle, helperTitleText, maxLength, required, textareaType, autoFocused, isEscapeNewlines, helperType, } = this.props;
        const classNames = [
            textareaType ? 'textarea-component' : 'input-text-component',
            mainColor ? 'main-color-set' : 'second-color-set',
            disabled ? 'disabled' : '',
            this.activeInputState ? 'focused' : '',
            this.inputValue ? 'filled' : '',
            errorMessage ? 'error' : '',
        ]
            .join(' ')
            .trim();
        const Field = textareaType ? 'textarea' : 'input';
        return (react_1.default.createElement("div", { className: classNames, "data-testid": 'input-text-component-' + id },
            react_1.default.createElement("label", { htmlFor: id },
                react_1.default.createElement(react_1.default.Fragment, null,
                    label,
                    ' ',
                    helperTitleText && (helperTitle || helperType) && (react_1.default.createElement(CustomToolTip_1.default, { title: helperTitle, info: helperTitleText, type: helperType, inverse: true })))),
            react_1.default.createElement(Field, { type: !textareaType && password ? 'password' : 'text', id: id, onBlur: !disabled ? this.onBlurInput : () => { }, onFocus: !disabled ? this.onFocusInput : () => { }, onChange: !disabled ? this.handleChange : () => { }, value: this.inputValue
                    ? isEscapeNewlines
                        ? (0, string_escape_newlines_1.stringEscapeNewlines)(this.inputValue)
                        : this.inputValue
                    : '', autoComplete: autoComplete, maxLength: maxLength, autoFocus: autoFocused }),
            react_1.default.createElement(FieldErrorSection_1.FieldErrorSection, { errorMessage: errorMessage, assistiveText: assistiveText, required: required })));
    }
}
exports.default = (0, mobx_react_1.observer)(InputText);
